/* The mockup's `.strength`: four 4px bars under the new password, filled by level, and its `.help`. */
.strength {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  margin-block-start: 2px;
}

.strength i {
  block-size: 4px;
  border-radius: 2px;
  background: var(--surface-sunken);
}

.strength[data-strength="1"] i:nth-child(-n + 1) {
  background: var(--danger-text);
}

.strength[data-strength="2"] i:nth-child(-n + 2) {
  background: var(--warning-text);
}

.strength[data-strength="3"] i:nth-child(-n + 3),
.strength[data-strength="4"] i {
  background: var(--success-text, var(--action-text));
}

.help {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
